export default {
    default: [
        {
            hoverControl: false,
            label: 'Analytics',
            membership: ['PLAN_1', 'PLAN_2', 'PLAN_3'],
            modules: [
                {
                    path: 'integrations/googleAnalytics',
                    content: {
                        template: 'Input',
                        placeholder: 'UA-XXXXX-X',
                        label: 'Google Analytics ID',
                    },
                },
                {
                    path: 'integrations/GTM',
                    content: {
                        template: 'Input',
                        placeholder: 'GTM-XXXXX',
                        label: 'Google Tag Manager ID',
                    },
                },
                {
                    path: 'integrations/hotjar',
                    content: {
                        template: 'Input',
                        placeholder: 'xxxx',
                        label: 'Hotjar Site ID',
                    },
                },
            ],
        },
        {
            hoverControl: false,
            label: 'Chat & Marketing',
            membership: ['PLAN_1', 'PLAN_2', 'PLAN_3'],
            modules: [
                {
                    path: 'integrations/crisp',
                    content: {
                        template: 'Input',
                        placeholder: 'xxxxxxxx-xxxx-...',
                        label: 'Crisp.Chat Website ID',
                    },
                },
                {
                    path: 'integrations/intercom',
                    content: {
                        template: 'Input',
                        placeholder: 'xxxx',
                        label: 'Intercom App ID',
                    },
                },
                {
                    path: 'integrations/pixel',
                    content: {
                        template: 'Input',
                        placeholder: 'xxxx',
                        label: 'Facebook Pixel ID',
                    },
                },
            ],
        },
    ],
};
